<ejs-grid #grid
          class="grid-with-footer"
          width="100%"
          rowHeight="38"
          [dataSource]="data"
          [allowSorting]="true"
          [filterSettings]="filterSettings"
          [allowFiltering]="true"
          [allowPaging]="true"
          [pageSettings]="pageSettings"
          [editSettings]="editSettings"
          [searchSettings]="searchOptions"
          [showColumnChooser]='true'
          [toolbar]='toolbarOptions'
          (actionComplete)="actionComplete($event)"
          (actionBegin)="actionBegin($event)"
          (queryCellInfo)="addTooltip($event)"
          (commandClick)="commandClicked($event)">
  <e-columns>
    <e-column field="id"
              [visible]="false"
              [isPrimaryKey]="true"
              [showInColumnChooser]="false">
    </e-column>
    <e-column field="firstEntryDateTime"
              type="date"
              [filter]="dateFilter"
              headerText="{{'i18n.domain.parker-registration.fields.registrationDateTime' | translate}}"
              clipMode="EllipsisWithTooltip"
              width="155px">
      <ng-template #template let-data>
        {{data.firstEntryDateTime | date:'dd.MM.yyyy HH:mm:ss'}}
      </ng-template>
    </e-column>
    <e-column field="parkingDuration"
              [allowFiltering]="false"
              headerText="{{'i18n.domain.parker-registration.fields.parkingDuration' | translate}}"
              width="80px"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        {{transformToHours(data.parkingDuration)}}
      </ng-template>
    </e-column>
    <e-column field="maxIntendedParkingDurationMinutes"
              [allowFiltering]="false"
              headerText="{{'i18n.domain.parker-registration.fields.maxIntendedParkingDurationMinutes' | translate}}"
              minWidth="80px"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        {{transformToHours(data.maxIntendedParkingDurationMinutes)}}
      </ng-template>
    </e-column>
    <e-column field="isClosed"
              [allowFiltering]="false"
              [allowSorting]="false"
              width="80px"
              headerText="{{'i18n.domain.parker-registration.fields.present' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        <span class="e-icons" [class.icon-checkmark]="!data.isClosed"></span>
      </ng-template>
    </e-column>
    <e-column field="registeredZone.name"
              type="string"
              headerText="{{'i18n.domain.parker-registration.fields.zone' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        {{data.registeredZone?.name}}
      </ng-template>
    </e-column>
    <e-column type="string" field="knownTag.parker.firstName"
      headerText="{{'i18n.domain.parker-registration.fields.parker-firstname' | translate}}" clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column type="string" field="knownTag.parker.lastName"
      headerText="{{'i18n.domain.parker-registration.fields.parker-lastname' | translate}}" clipMode="EllipsisWithTooltip">
    </e-column>
    <!-- <e-column field="name"
              [allowFiltering]="false"
              [allowSorting]="false"
              headerText="{{'i18n.domain.parker-registration.fields.name' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        {{ data.knownTag?.parker ? data.knownTag.parker.firstName + ' ' + data.knownTag.parker.lastName : ''}}
      </ng-template>
    </e-column> -->
    <e-column field="{{controlPlateField}}"
              type="string"
              [allowSorting]="false"
              headerText="{{'i18n.domain.parker-registration.fields.plate' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        <span class="text-uppercase">{{getControlPlate(data)}}</span>
      </ng-template>    </e-column>
    <e-column field="knownTag.controlPlateType"
              headerText="{{'i18n.domain.parker-registration.fields.control-plate-type' | translate}}"
              clipMode="EllipsisWithTooltip"
              [filter]="controlPlateTypeFilter"
              [visible]="false">
      <ng-template #template let-data>
        {{ formatControlPlateType(data) | translate}}
      </ng-template>
      <ng-template #filterItemTemplate let-data>
        {{ formatControlPlateType(data) | translate}}
      </ng-template>
    </e-column>
    <e-column type="string"
              field="{{countryCodeField}}"
              [allowSorting]="false"
              width="100"
              headerText="{{'i18n.domain.parker-registration.fields.country' | translate}}"
              clipMode="EllipsisWithTooltip">
      <ng-template #template let-data>
        <span class="text-uppercase">{{getCountryCode(data)}}</span>
      </ng-template>
    </e-column>
    <e-column field="knownTag.barcode"
              type="string"
              [visible]="false"
              headerText="{{'i18n.domain.parker-registration.fields.barcode' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="knownTag.identificationCode"
              [visible]="false"
              headerText="{{'i18n.domain.parker-registration.fields.knownTagId' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="knownTag.description"
              type="string"
              [visible]="false"
              headerText="{{'i18n.domain.parker-registration.fields.description' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column field="knownTag.parker.company.name"
              type="string"
              headerText="{{'i18n.domain.parker-registration.fields.company' | translate}}"
              clipMode="EllipsisWithTooltip"
              [visible]="false">
    </e-column>
    <e-column field="client.name"
              type="string"
              headerText="{{'i18n.domain.parker-registration.fields.client' | translate}}"
              clipMode="EllipsisWithTooltip"
              [visible]="false">
    </e-column>
    <e-column field="knownTag.parker.title"
              [visible]="false"
              [allowFiltering]="false"
              [allowSorting]="false"
              headerText="{{'i18n.domain.parker-registration.fields.title' | translate}}"
              clipMode="EllipsisWithTooltip">
    </e-column>
    <e-column type="number"
              format="N2"
              width="150"
              field="{{calculatedParkingFeeField}}"
              headerText="{{'i18n.domain.parker-registration.fields.calculatedParkingFee' | translate}}"
              textAlign="right">
    </e-column>
    <e-column type="number"
              format="N2"
              width="150"
              field="{{totalParkingFeeField}}"
              headerText="{{'i18n.domain.parker-registration.fields.totalParkingFee' | translate}}"
              textAlign="right">
    </e-column>
    <e-column type="number"
              format="N2"
              width="150"
              field="paidParkingFee"
              [visible]="false"
              headerText="{{'i18n.domain.parker-registration.fields.paidParkingFee' | translate}}"
              textAlign="right">
    </e-column>
    <e-column field="currency"
              headerText="{{'i18n.shared.fields.currency' | translate}}"
              clipMode="EllipsisWithTooltip"
              width="100"
              textAlign="left"
              [filter]="currencyFilter">
      <ng-template #template let-data>
          {{formatCurrency(data.currency) | translate}}
      </ng-template>
      <ng-template #filterItemTemplate let-data>
        {{ formatCurrency(data.currency) | translate}}
      </ng-template>
    </e-column>
    <e-column field="{{offensesField}}"
              headerText="{{'i18n.domain.parker-registration.fields.offense' | translate}}"
              clipMode="EllipsisWithTooltip"
              [allowSorting]="false"
              [filter]="offenseFilter">
      <ng-template #template let-data>
        {{formatOffenseTypes(data)}}
      </ng-template>
    </e-column>
    <e-column headerText="" width="70px" [showInColumnChooser]="false">
      <ng-template #template let-data>
      @if (data.offenses.length) {
        <span class="icon-warning--alt--filled text-danger me-2"></span>
      }
      @if (data.penaltyIssued) {
        <span class="icon-currency--dollar" [ngClass]="{'price--line-through': (data.penaltyState == penaltyStateCancelled)}"></span>
      }
      </ng-template>
    </e-column>
    <e-column headerText="" width="120px" [commands]="gridCommands" [showInColumnChooser]="false"></e-column>
  </e-columns>
  <ng-template #editSettingsTemplate let-data>
    <app-parker-registration-evaluated-detail [parkingSession]="data" [zones]="zones">
    </app-parker-registration-evaluated-detail>
  </ng-template>
</ejs-grid>
<app-adjust-parker-registration-evaluated-dialog (functionExecuted)="onSessionAdjustFunctionExecuted()"></app-adjust-parker-registration-evaluated-dialog>
